var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1817 4.09082C11.818 5.45446 6.13623 11.4164 3.63623 13.6363L14.0908 16.8181",
    stroke: "#2A2D34"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.091,
    cy: 3.18182,
    r: 2.68182,
    fill: "#2A2D34",
    stroke: "#2A2D34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.091,
    cy: 16.8183,
    r: 2.68182,
    fill: "#2A2D34",
    stroke: "#2A2D34"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.63636,
    cy: 13.6364,
    r: 3.13636,
    fill: "#2A2D34",
    stroke: "#2A2D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.349f2d73d2a2455f0c9c134926edb50f.svg";
export { ForwardRef as ReactComponent };